import React, { useState } from 'react';
import { G } from '../theme';
import FadeIn from './FadeIn';

export default function ModuleCard({ m, idx, isLast }) {
  const [open, setOpen] = useState(false);
  return (
    <FadeIn delay={idx * 0.05}>
      <div style={{ display:"flex", gap:0 }}>
        {/* Timeline column */}
        <div style={{ display:"flex", flexDirection:"column", alignItems:"center", width:40, flexShrink:0 }}>
          {/* Circle */}
          <div onClick={() => setOpen(!open)} style={{
            width:28, height:28, borderRadius:"50%",
            border:`2px solid ${open ? G.g700 : "#C8C8C0"}`,
            background: open ? G.g700 : "#fff",
            display:"flex", alignItems:"center", justifyContent:"center",
            cursor:"pointer", flexShrink:0, zIndex:1,
            transition:"all 0.2s",
          }}>
            {open && <div style={{ width:10, height:10, borderRadius:"50%", background:"#fff" }} />}
          </div>
          {/* Vertical line */}
          {!isLast && (
            <div style={{ width:2, flex:1, background: open ? G.g600 : "#E0E0D8", minHeight:40, marginTop:0, transition:"background 0.3s" }} />
          )}
        </div>

        {/* Content */}
        <div style={{ flex:1, paddingLeft:20, paddingBottom: isLast ? 0 : 8 }}>
          {/* Header row */}
          <div onClick={() => setOpen(!open)} style={{ display:"flex", alignItems:"center", justifyContent:"space-between", cursor:"pointer", paddingTop:2, paddingBottom: open ? 12 : 20 }}>
            <div style={{ display:"flex", alignItems:"center", gap:12 }}>
              <span style={{ fontSize:18 }}>{m.icon}</span>
              <span style={{ fontSize:15, fontWeight:600, color: open ? G.g700 : G.gray8, transition:"color 0.2s" }}>{m.title}</span>
            </div>
            <div style={{
              width:28, height:28, borderRadius:"50%", border:`1.5px solid ${G.g600}`,
              display:"flex", alignItems:"center", justifyContent:"center",
              color:G.g700, fontSize:14, flexShrink:0, marginLeft:12,
              transition:"transform 0.2s",
              transform: open ? "rotate(180deg)" : "rotate(0deg)",
            }}>↑</div>
          </div>

          {/* Expanded content */}
          {open && (
            <div style={{ paddingBottom:24 }}>
              {/* Objectives */}
              <div style={{ marginBottom:16 }}>
                {m.objectives.map((o,i) => (
                  <div key={i} style={{ display:"flex", gap:10, marginBottom:8, alignItems:"flex-start" }}>
                    <span style={{ color:G.g600, fontSize:14, flexShrink:0, marginTop:1 }}>–</span>
                    <span style={{ fontSize:14, color:G.gray6, lineHeight:1.6 }}>{o}</span>
                  </div>
                ))}
              </div>

              {/* Content tags */}
              <div style={{ display:"flex", flexWrap:"wrap", gap:6, marginBottom:16 }}>
                {m.content.map((c,i) => (
                  <span key={i} style={{ fontSize:12, background:G.g100, color:G.g800, padding:"4px 12px", borderRadius:20, border:`1px solid ${G.g200}` }}>{c}</span>
                ))}
              </div>

              {/* Practical */}
              <div style={{ background:"#FAFAF8", border:"1px solid #EAEAE4", borderRadius:10, padding:"12px 16px" }}>
                <div style={{ fontSize:11, fontWeight:700, color:G.amber, textTransform:"uppercase", letterSpacing:"0.6px", marginBottom:10 }}>🔬 Travaux pratiques</div>
                {m.practical.map((p,i) => (
                  <div key={i} style={{ display:"flex", gap:10, marginBottom:6, alignItems:"flex-start" }}>
                    <span style={{ color:G.g600, fontSize:13, flexShrink:0, marginTop:1 }}>✓</span>
                    <span style={{ fontSize:13, color:G.gray8, lineHeight:1.5 }}>{p}</span>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </FadeIn>
  );
}

